import { getArtigosRecentes } from "@/lib/blog.functions";
import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/seo/JsonLd";
import { SaudeHormonal, faq } from "@/components/itv/pages/SaudeHormonal";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import { getSiteData } from "@/lib/site-data.functions";
import {
  breadcrumbSchema,
  faqSchema,
  medicalWebPageSchema,
  physicianSchema,
  type Trilha,
} from "@/lib/schema";

const PATH = "/tratamentos/saude-hormonal/";
const TITLE = "Saúde Hormonal e Implante Hormonal | Dr. Thiago Viana";
const DESCRIPTION =
  "Investigação clínica de desequilíbrios hormonais e indicação de reposição ou implante hormonal apenas quando há critério médico individual e seguro.";

export const Route = createFileRoute("/tratamentos/saude-hormonal")({
  loader: async () => {
    const [site, head, artigos] = await Promise.all([getSiteData(), carregarPaginaSimples(PATH, TITLE, DESCRIPTION), getArtigosRecentes()]);
    return { site, artigos, ...head };
  },
  staticData: { declaraPhysician: true },
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  const { site, artigos } = Route.useLoaderData();
  const trilha: Trilha[] = [
    { nome: "Home", path: "/" },
    { nome: "Tratamentos", path: "/tratamentos/" },
    { nome: "Saúde hormonal", path: PATH },
  ];

  return (
    <>
      <SaudeHormonal artigos={artigos} />
      <JsonLd data={medicalWebPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION })} />
      <JsonLd data={breadcrumbSchema(trilha)} />
      <JsonLd data={faqSchema(faq)} />
      <JsonLd data={physicianSchema(site.doctor, "completa")} />
    </>
  );
}
